<template>
  <el-dialog
    :visible="visible"
    width="430px"
    custom-class="balance-days-warning-dialog"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="warning-content">
      <div class="warning-icon">!</div>
      <h2>账户余额不足提醒</h2>
      <div class="balance-label">当前账户余额</div>
      <div class="balance">¥{{ formatMoney(detail.balance) }}</div>
      <div class="metrics">
        <div><span>近30天日均消耗</span><strong>¥{{ formatMoney(detail.averageDailyConsumption) }}</strong></div>
        <div><span>预计可使用</span><strong class="danger">{{ detail.availableDays || 0 }} 天</strong></div>
        <div><span>预计耗尽日期</span><strong class="danger">{{ exhaustionDate }}</strong></div>
      </div>
      <div class="progress"><div :style="{ width: progressWidth + '%' }" /></div>
      <div class="warning-text">按当前消耗速度，余额预计将于 {{ detail.estimatedExhaustionDate }} 耗尽</div>
      <p>为避免影响机构正常使用，请及时充值。</p>
      <div class="actions">
        <el-button @click="$emit('close')">我知道了</el-button>
      </div>
      <small>本提醒由系统统一规则触发 · 可用天数不足时自动弹出</small>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'BalanceDaysWarningDialog',
  props: {
    visible: { type: Boolean, default: false },
    detail: { type: Object, default: () => ({}) }
  },
  computed: {
    exhaustionDate() {
      return this.detail.estimatedExhaustionDate ? this.detail.estimatedExhaustionDate.slice(5) : '--'
    },
    progressWidth() {
      const threshold = Number(this.detail.warningDays)
      return threshold > 0 ? Math.max(0, Math.min(100, Number(this.detail.availableDays) / threshold * 100)) : 0
    }
  },
  methods: {
    formatMoney(value) {
      return Number(value || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  }
}
</script>

<style lang="scss">
.balance-days-warning-dialog {
  border-radius: 16px;
  .el-dialog__header { padding: 0; }
  .el-dialog__body { padding: 26px 28px 22px; }
  .warning-content { text-align: center; color: #252b35; }
  .warning-icon { width: 56px; height: 56px; margin: 0 auto 12px; border-radius: 50%; background: #fff3e3; color: #ef9416; font-size: 32px; line-height: 56px; }
  h2 { margin: 0 0 10px; font-size: 18px; }
  .balance-label, .metrics span, p { color: #8792a7; font-size: 13px; }
  .balance { font-size: 32px; font-weight: 700; margin: 4px 0 16px; }
  .metrics { display: flex; border: 1px solid #e1e8f5; border-radius: 9px; overflow: hidden; }
  .metrics > div { flex: 1; min-width: 0; padding: 18px 3px; background: #fafcff; }
  .metrics > div + div { border-left: 1px solid #e1e8f5; }
  .metrics span, .metrics strong { display: block; }
  .metrics strong { margin-top: 14px; font-size: 16px; }
  .danger, .warning-text { color: #f04438; }
  .progress { height: 8px; margin: 12px 0 8px; border-radius: 8px; background: #e8edf5; overflow: hidden; }
  .progress > div { height: 100%; border-radius: 8px; background: linear-gradient(90deg, #f59a15, #ee4b49); }
  .warning-text { font-size: 12px; }
  p { margin: 16px 0 20px; }
  .actions { display: flex; gap: 12px; }
  .actions .el-button { flex: 1; margin: 0; }
  small { display: block; margin-top: 16px; color: #a0aabe; font-size: 11px; }
}
</style>
